import type { CountryCode } from 'libphonenumber-js';

// Map country codes to flag emojis
const countryFlags: Record<string, string> = {
  FR: '🇫🇷', // France
  BE: '🇧🇪', // Belgium
  CH: '🇨🇭', // Switzerland
  LU: '🇱🇺', // Luxembourg
  MC: '🇲🇨', // Monaco
  CA: '🇨🇦', // Canada
  US: '🇺🇸', // United States
  GB: '🇬🇧', // United Kingdom
  DE: '🇩🇪', // Germany
  ES: '🇪🇸', // Spain
  IT: '🇮🇹', // Italy
  PT: '🇵🇹', // Portugal
  NL: '🇳🇱', // Netherlands
  MA: '🇲🇦', // Morocco
  DZ: '🇩🇿', // Algeria
  TN: '🇹🇳', // Tunisia
};

export const getCountryFlag = (countryCode: CountryCode): string => {
  return countryFlags[countryCode] || '🏳️';
};

// Get country name in French
export const getCountryName = (countryCode: CountryCode): string => {
  const countryNames: Record<string, string> = {
    FR: 'France',
    BE: 'Belgique',
    CH: 'Suisse',
    LU: 'Luxembourg',
    MC: 'Monaco',
    CA: 'Canada',
    US: 'États-Unis',
    GB: 'Royaume-Uni',
    DE: 'Allemagne',
    ES: 'Espagne',
    IT: 'Italie',
    PT: 'Portugal',
    NL: 'Pays-Bas',
    MA: 'Maroc',
    DZ: 'Algérie',
    TN: 'Tunisie',
  };
  
  return countryNames[countryCode] || countryCode;
};